import { useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen } from '../experiments/useExperiment';
import { useCurrentStep } from './useCurrentStep';
import { Tracker } from '../store/tracking/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useSelector, useDispatch } from 'react-redux';
import { getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
export const useSearchAndPrefillExperiment = () => {
  const {
    currentStep
  } = useCurrentStep();
  const dispatch = useDispatch();
  const companyName = useSelector(state => getSignupDataValue(state, Data.CompanyName));
  const guessedCompanyName = useSelector(getGuessedDataBreeze(Data.CompanyName));
  const {
    isAssignedToVariant: isAssignedToACQ174
  } = useExperiment(ExperimentKeys.ACQ0174, TrackWhen.never);
  const isAssignedToACQ174Variant = isAssignedToACQ174();
  const isInPrefillExperiment = isAssignedToACQ174();
  const trackCompanyNameChanged = () => {
    if (isInPrefillExperiment) {
      if (companyName !== guessedCompanyName) {
        dispatch(Tracker.signupInteraction('breeze-company-name-prefilled-changed'));
      }
    }
  };
  const searchAndPrefillHelperText = isInPrefillExperiment ? `views.${currentStep}.searchAndPrefillHelperText` : `views.${currentStep}.help`;
  return {
    isAssignedToACQ174Variant,
    searchAndPrefillHelperText,
    trackCompanyNameChanged
  };
};